import React from 'react';

import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

import './MenuBar.css';
import 'bootstrap/dist/css/bootstrap.min.css';

const MenuBar = ({ logo, options }) => {
  return (
    <div className="navbar">
      <Navbar fixed="top" bg="light" expand="sm">
        <Navbar.Brand href="#top">{logo}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            {options.map((option) =>
              <Nav.Link
                key={option.name}
                href={option.type === "section" ? "#"+option.name+"" : "mailto: kayla@kaylaelias.com"}>{option.text}</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}


export default MenuBar;
